import { css, StyleDeclarationValue } from 'aphrodite';
import * as React from 'react';
import { PopoverPosition } from 'react-tiny-popover';
import { HoverCard, HoverCardContent, HoverCardTrigger } from '../../../../web/components/HoverCard';
import { InfoIcon } from '../../../../web/components/svgs/icons/InfoIcon';
import { baseStyleSheet } from '../../../../web/styles/styles';
import { styleSheet } from './styles';

interface IAccountDetailsInfoFieldProps
	extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
	disabled?: boolean;
	editingStyles?: StyleDeclarationValue[];
	fillColor?: string;
	info?: string | React.ReactNode;
	isEditMode?: boolean;
	label: React.ReactNode;
	labelStyles?: StyleDeclarationValue[];
	placement?: Exclude<PopoverPosition, 'custom'>[];
	styles?: StyleDeclarationValue[];
	symbol?: string;
	valueStyles?: StyleDeclarationValue[];
}

export const AccountDetailsInfoField: React.FC<IAccountDetailsInfoFieldProps> = props => {
	const {
		className,
		disabled,
		label,
		styles,
		placement,
		fillColor,
		labelStyles,
		valueStyles,
		children,
		isEditMode,
		editingStyles,
		info,
		...restProps
	} = props;
	return (
		<div
			{...restProps}
			className={`${className || ''} ${css(styleSheet.infoFieldContainer, ...(styles || []))} ${
				isEditMode ? css(styleSheet.infoFieldEditing, ...(editingStyles || [])) : ''
			} `}
		>
			{!!label && (
				<div className={`${css(styleSheet.infoFieldLabel, baseStyleSheet.truncateText, ...(labelStyles || []))}`}>
					{label}
					{info && (
						<HoverCard>
							{/* Hover-card content is not reliably announced, so a plain-text hint doubles as the
							    trigger's name rather than being available to pointers alone. */}
							<HoverCardTrigger
								className={css(styleSheet.infoIcon)}
								aria-label={typeof info === 'string' ? info : undefined}
							>
								<InfoIcon fillColor={fillColor || ''} />
							</HoverCardTrigger>
							<HoverCardContent styles={[styleSheet.infoMessage]}>{info}</HoverCardContent>
						</HoverCard>
					)}
				</div>
			)}
			{!!children && <div className={`${css(styleSheet.infoFieldValue, ...(valueStyles || []))}`}>{children}</div>}
		</div>
	);
};
